import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import './Button.scss'

interface IButtonProps {
  width?: string
  height?: string
  padding?: string
  margin?: string
  className?: string
  to?: string
  type?: 'primary' | 'success' | 'error' | 'warning' | 'info' | 'inherit' | 'cancel'
  variant?: 'filled' | 'outlined' | 'text' | 'icon' | 'grey' | 'white' | 'back' | 'secondary' | 'close'
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  children: React.ReactNode
  fontSize?: string
  onClick?: () => void
  [key: string]: any
  dataTest?: string
}

const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
  (
    {
      width,
      height,
      padding,
      margin,
      className,
      to,
      type = 'primary',
      variant = 'filled',
      disabled = false,
      children,
      fontSize,
      onClick,
      size = 'medium',
      dataTest,
      ...props
    },
    ref,
  ) => {
    const inlineStyles = {
      '--button-width': width || '100%',
      '--button-height': height || (size === 'small' ? '32px' : size === 'medium' ? '40px' : '48px'),
      '--button-padding': padding || '10px 16px',
      '--button-margin': margin || '0',
      '--button-font-size': fontSize || '16px',
    }

    const buttonClass = classNames('button', `button--${variant}`, { 'button--disabled': disabled }, className)

    return !to ? (
      <button
        ref={ref}
        type="button"
        data-test={dataTest}
        className={buttonClass}
        style={inlineStyles as React.CSSProperties}
        data-type={type} // Attach data-type for SCSS styling
        disabled={disabled}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    ) : (
      <Link to={to} style={{ textDecoration: 'none' }}>
        <button
          ref={ref}
          type="button"
          className={buttonClass}
          style={inlineStyles as React.CSSProperties}
          data-type={type} // Attach data-type for SCSS styling
          disabled={disabled}
          onClick={onClick}
          {...props}
        >
          {children}
        </button>
      </Link>
    )
  },
)

export default Button
